import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function country() {
    return {
        index,
        get,
        create,
        update
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`country/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`country/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('country/create', data);
    }

    function update(data) {
        return axiosInstance.patch('country/update', data);
    }
}
